import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
import { down } from "../../../styles/breakpoints";

const useStyles = createUseStyles((_) => ({
  carCard: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    borderRadius: "15px",
    padding: "30px",
    minWidth: 0,
    backgroundColor: colors.WHITE,
    boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.09)",
    justifyContent: "space-between",
    [down.sm]: {
      padding: "20px",
    },
  },

  divCar1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    minWidth: 0,
  },

  divCar: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    flexWrap: "wrap",
    gap: "12px",
    minWidth: 0,
  },

  divText2: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    minWidth: 0,
  },

  divChart: {
    flexShrink: 0,
    /* The donut was pinned to 93x90 with `!important`, which overrode
       Recharts' own responsive sizing and clipped the label on small cards.
       A plain declaration is enough — nothing was competing with it. */
    "& .recharts-wrapper": {
      width: 93,
      height: 90,
      maxWidth: "100%",
    },
    "& .recharts-text": {
      fontFamily: "Poppins-Regular",
      fontSize: "25px",
      fill: colors.darkblack,
    },
  },
}));

export default useStyles;
